import Modal from '@mozaic-ds/freemarker/js/modules/_modal.js';
import { addEvent } from '../includes/_events';
import { sendButtonClick } from './tracking';
export const initModals = self => {
  if (!self._modals) {
    self._modals = {};
  }
  addEvent(document, 'click', el => {
    const modalId = el.matchingTarget.dataset.modalId;
    if (!modalId) {
      console.error('Missing modal id', el.matchingTarget);
      return;
    }
    if (!self._modals[modalId]) {
      self._modals[modalId] = new Modal({
        classContent: modalId,
        onOpen: () => {
          sendButtonClick({
            ...el.matchingTarget.dataset,
            buttonName: 'open modal',
            featureName: el.matchingTarget.dataset.featureName || el.matchingTarget.id
          }, true);
        }
      });
    }
    self._modals[modalId].open();
  }, '.js-generic-modal', self);
};